module.exports = __webpack_public_path__ + "img/destination_spice_ln.04be56df.jpg";